<template>
  <div class="mask">
    <div class="layer">
      <div class="lay-tit">{{title}}</div>
      <div class="outInput">
        <el-input
                  maxlength="200"
                  resize="none"
                  type="textarea"
                  v-model="value"
                  rows="2"
                  :placeholder="placeholder">
        </el-input>
      </div>
      <div class="layBtn">
        <button @click="handleCancel" class="butStyle whiteBtn">取消</button>
        <button @click="handleConfirm" class="butStyle pinkBtn">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "baseMessageBox",
    props: {
      placeholder: {
        type: String,
        required: false,
        default: '请输入内容',
      },
      title: {
        type: String,
        required: false,
        default: '提示'
      },
    },
    data() {
      return {
        value: this.input
      }
    },
    methods: {
      // 取消事件
      handleCancel() {
        this.$emit('cancel')
      },
      // 确定事件
      handleConfirm() {
        // 把result对象传递上去
        this.$emit('confirm', {value: this.value})
      },
    }
  }
</script>

<style scoped>
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /*background: rgba(0,0,0,0.5);*/
    background:rgba(0,0,0,0.6);
    z-index: 99;
  }

  .mask .layer {
    position: absolute;
    width: 288px;
    top: 40%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #eee;
    /* box-shadow: 6px 6px 12px #ccc; */
    padding-bottom: 19px;
  }

  .layer .lay-tit {
    height: 40px;
    line-height: 40px;
    color: #2B2727;
    font-weight: bold;
    text-indent: 14px;
    background: #eee;
    font-size: 12px;
  }

  .outInput {
    width: 260px;
    height: 40px;
    margin: 14px auto 31px;
    text-align: center;
    line-height: 40px;
  }

  .layBtn {
    text-align: center;
  }

  .layBtn .butStyle {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
  }

  .layBtn .butStyle + .butStyle {
    margin-left: 20px;
  }
</style>
